
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.75 17.7h3.2c.5 1.8 1.8 3.4 3.8 3.5 2.3.1 3.6-1.6 4.2-3.5h24.7c1 0 1-3.1 0-3.1h-24.7c-.4-2-1.7-3.6-3.9-3.6s-3.5 1.6-4 3.5h-3.2c-1 0-1 3.2-.1 3.2zm7.1-3.5c1-.1 2.8.6 3 1.8v.3c-.2 1.1-1.8 1.8-2.8 1.8-.9 0-2.6-.7-2.8-1.8V16c.2-1.1 1.7-1.8 2.6-1.8zM47.75 28.1h-7.4c-.5-1.9-1.8-3.5-4-3.5s-3.5 1.6-4 3.5h-20.6c-1 0-1 3.1 0 3.1h20.6c.5 1.8 1.8 3.4 3.8 3.5 2.3.1 3.6-1.6 4.2-3.5h7.4c.9.1.9-3.1 0-3.1zm-11.4 3.5c-.9 0-2.6-.7-2.8-1.8v-.3c.2-1 1.7-1.7 2.6-1.8 1-.1 2.8.6 3 1.8v.3c-.2 1.2-1.8 1.8-2.8 1.8zM29.95 41.7h17.8c.9 0 .9 3.1 0 3.2h-17.8c-.6 1.9-1.9 3.6-4.2 3.5-2-.1-3.3-1.7-3.8-3.5h-10.1c-1 0-1-3.2 0-3.2h10.1c.5-1.9 1.8-3.5 4-3.5s3.5 1.6 4 3.5zm-6.9 1.7c.2 1.1 1.9 1.8 2.8 1.8 1 0 2.6-.7 2.8-1.8v-.3c-.2-1.2-2-1.9-3-1.8-.9.1-2.4.8-2.6 1.8v.3z"}})])
          )
        }
      }
    